import { CapaQuotationUserFileType } from '@generated/graphql';
import useClient from '@hooks/useClient';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import GnbPopupMenuPresenter from './GnbPopupMenuPresenter';
import AppConfig from '@config';
import * as Assets from '@assets';
import {
  authStorageClear,
  clearStorageAll,
  STORAGE_ACTION
} from '@utils/storage';
import useRequest from '@hooks/useRequest';
import useSwitchService from '@hooks/useSwitchService';
import useDashboard from '@hooks/useDashboard';

const GnbPopupMenuContainer: React.FC = () => {
  const history = useHistory();
  const { handleSwitchService } = useSwitchService();

  const {
    clientState: { managerName, files },
    onInitClient
  } = useClient();

  const { onInitRfqState } = useRequest();

  const { onInitDashboard, onInitSelectedQuotation } = useDashboard();

  const profileLogoImgSrc = useMemo(() => {
    let avatarFileId: string | undefined | null;

    if (files && files.length > 0) {
      avatarFileId = files.find(
        (file) => file.fileType === CapaQuotationUserFileType.Profile
      )?.fileId;
    }

    return avatarFileId
      ? `${AppConfig.fileApiUrl}/file/${avatarFileId}`
      : Assets.DefaultProfile;
  }, [files]);

  const handleLogout = () => {
    localStorage.removeItem(STORAGE_ACTION.REDIRECT_PATH);
    authStorageClear();
    clearStorageAll();
    onInitClient();
    onInitRfqState();
    onInitDashboard();
    onInitSelectedQuotation();
    history.push('/login');
  };

  const onClickHandle = (value: string) => {
    history.push(value);
  };

  return (
    <GnbPopupMenuPresenter
      managerName={managerName ?? ''}
      profileLogoImgSrc={profileLogoImgSrc}
      handleSwitchService={handleSwitchService}
      onClickHandle={onClickHandle}
      handleLogout={handleLogout}
    />
  );
};

export default GnbPopupMenuContainer;
